/** @format */

const responseSelectors = {
  reviewCarousel: '.jdgm-carousel-item',
  reviewAuthor: '.jdgm-carousel-item__reviewer-name',
  reviewRatingLabel: '.jdgm-carousel-item__review-rating',
  reviewDate: '.jdgm-carousel-item__timestamp',
  reviewTitle: '.jdgm-carousel-item__review-title',
  reviewBody: '.jdgm-carousel-item__review-body p',
  reviewProductImage: '.jdgm-carousel-item__product-image'
};

const tokens = {
  publicApiKey: '1rSFmkUXQ-FRuTXvNUAK6qKtU1k',
  shopDomain: 'visbiomevet.myshopify.com'
};

class JudgemeReviews extends HTMLElement {
  constructor() {
    super();
    this.reviewsWrapper = document.querySelector('judgeme-reviews');
  }

  async connectedCallback() {
    const reviewsUrl = `https://judge.me/api/v1/widgets/featured_carousel?api_token=${tokens.publicApiKey}&shop_domain=${tokens.shopDomain}`;
    try {
      const response = await fetch(reviewsUrl);
      const reviews = await response.json();

      const parsedNode = new DOMParser().parseFromString(reviews.featured_carousel, 'text/html');

      this.renderReviews(parsedNode);
    } catch (error) {
      console.error(error);
    }
  }

  renderReviews(reviews) {
    const carouselItems = reviews.querySelectorAll(responseSelectors.reviewCarousel);

    carouselItems.forEach((item) => {
      const author = item.querySelector(responseSelectors.reviewAuthor).textContent;
      const date = item.querySelector(responseSelectors.reviewDate).textContent;
      const title = item.querySelector(responseSelectors.reviewTitle).textContent;
      const body = item.querySelector(responseSelectors.reviewBody).textContent;
      const imageUrl = item.querySelector(responseSelectors.reviewProductImage).dataset.srcRetina;
      const starRating = item.querySelector(responseSelectors.reviewRatingLabel).ariaLabel.match(/(\d+)/)[0];

      const reviewSlide = document.getElementById('reviewSlide').content.cloneNode(true);
      const reviewMedia = reviewSlide.querySelector('.review-media');
      const reviewCustomerName = reviewSlide.querySelector('.review-customer-name');
      const reviewStarRating = reviewSlide.querySelector('.review-star-rating');
      const reviewTitle = reviewSlide.querySelector('.review-title');
      const reviewContent = reviewSlide.querySelector('.review-text-content');
      const reviewDate = reviewSlide.querySelector('.review-date');

      if (imageUrl) {
        const reviewMediaImage = document.createElement('img');
        reviewMediaImage.src = imageUrl;
        reviewMediaImage.setAttribute('loading', 'lazy');
        reviewMedia.appendChild(reviewMediaImage);
      }

      reviewCustomerName.textContent = author;
      reviewTitle.textContent = title;
      reviewContent.textContent = body;
      reviewDate.textContent = new Date(date).toLocaleDateString(
        {},
        { year: 'numeric', month: 'long', day: 'numeric' }
      );

      const filledStar = document.getElementById('filledStar').content.cloneNode(true);
      const emptyStar = document.getElementById('emptyStar').content.cloneNode(true);

      for (let i = 0; i < 5; i++) {
        if (i < starRating) {
          reviewStarRating.appendChild(filledStar.cloneNode(true));
        } else {
          reviewStarRating.appendChild(emptyStar.cloneNode(true));
        }
      }
      this.reviewsWrapper.appendChild(reviewSlide);
    });
  }
}

customElements.define('judgeme-reviews', JudgemeReviews);

setTimeout(function(){
  const judgemeswiper = new Swiper('.reviews-section', {
    direction: 'horizontal',  
    loop: true,
    autoplay: {
      delay: 4000,
    },
    slidesPerView: 1,
      breakpoints: {
      768: {
        slidesPerView: 1,
      },
      1024: {
        slidesPerView: 1,
      },
    },

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
      enabled: true
    },
  });
  judgemeswiper.init();
},300)
